/* eslint-disable react/jsx-handler-names */
import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import Icon from '../../../Icon';
import { useVirtualVisit } from '../../../../redux/opentok/hooks/useVirtualVisit';
import styles from './styles.styl';

function CollapsedBar({ activeUser }) {
  const { viewOptions } = useVirtualVisit();

  const name = useMemo(() => get(activeUser, 'name'), [activeUser]);

  return (
    <div className={styles.root}>
      <span className={styles.name}>{name}</span>
      <div className={styles.icon} onClick={viewOptions.expandView}>
        <Icon name="fullscreen" size={16} />
      </div>
    </div>
  );
}

CollapsedBar.propTypes = {
  activeUser: PropTypes.object,
};

export default CollapsedBar;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/CollapsedBar/index.jsx